<template>
    <alzata-odata-table
        ref="usersGrid"
        clickable
        title="Roles"
        endpoint="/api/v1/Roles"
        :columns="[
            {
                id: 'Name',
                label: 'Name',
                sortable: true,
            },
        ]"
    >
    </alzata-odata-table>
</template>

<script>
export default {
  name: 'AlzataRoleList',
};
</script>
